import axios from 'axios';
import { api, headers } from '../../app/conf';

export const getResponsesServices = (token, botId, intentId) =>
    axios({
        method: 'get',
        url: `${api}/v1/chatbot/bots/${botId}/intents/${intentId}/responses/`,
        headers: {
            ...headers,
            'X-Access-Token': token
        }
});

export const putResponseServices = (token, botId, respId, response) =>
    axios({
        method: 'put',
        url: `${api}/v1/chatbot/bots/${botId}/responses/${respId}`,
        headers: {
            ...headers,
            'X-Access-Token': token
        },
        data: response

});

export const postResponseServices = (token, botId, response) =>
    axios({
        method: 'post',
        url: `${api}/v1/chatbot/bots/${botId}/responses/`,
        headers: {
            ...headers,
            'X-Access-Token': token
        },
        data: response
});

export const deleteResponseServices = (token, botId, id) =>
    axios({
        method: 'delete',
        url: `${api}/v1/chatbot/bots/${botId}/responses/${id}`,
        headers: {
            ...headers,
            'X-Access-Token': token
        }
    });